/**
 * Do not edit directly
 */

export default "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTE2LjUgMTUuMiAgICAgICAgICAgTDEyIDE5LjcgICAgICAgICAgIEw3LjUgMTUuMiAgICAgICAgICAgTDguNSAxNC4yICAgICAgICAgICBMMTEuMiAxNi45ICAgICAgICAgICBMMTEuMiAzLjIgICAgICAgICAgIEwxMi44IDMuMiAgICAgICAgICAgTDEyLjggMTYuOSAgICAgICAgICAgTDE1LjUgMTQuMiAgICAgICAgICAgWiIvPjwvc3ZnPg==";